import React from 'react'

export default function ConfirmDialog({ open, onClose, text, onConfirm, confirmLabel = 'Xác nhận', title = 'Thông báo' }) {
  if (!open) return null

  return (
    <div className="traffic-fine-package-confirm-overlay" onClick={onClose} role="presentation">
      <div className="traffic-fine-package-confirm-dialog" role="dialog" aria-modal="true" aria-label={title} onClick={(e) => e.stopPropagation()}>
        <div className="traffic-fine-package-confirm-content">
          <div className="traffic-fine-package-confirm-title">{title}</div>
          <div className="traffic-fine-package-confirm-text">{text}</div>
        </div>

        <div className="traffic-fine-package-confirm-divider" />

        <div className="traffic-fine-package-confirm-footer">
          <button type="button" className="traffic-fine-package-confirm-btn is-close" onClick={onClose}>
            Đóng
          </button>

          <div className="traffic-fine-package-confirm-v-divider" />

          <button type="button" className="traffic-fine-package-confirm-btn is-confirm" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}
